<template>
  <span class="z-input" :style="`width: ${width}px`">
    <label v-if="label">{{ label }}</label>
    <span class="z-input-inner">
      <input
        v-if="element === 'input'"
        ref="input"
        :type="type"
        v-bind="$attrs"
        :value="value"
        :placeholder="placeholder"
        v-on="inputListeners"
      />
      <textarea
        v-else
        ref="input"
        :type="type"
        v-bind="$attrs"
        :value="value"
        :placeholder="placeholder"
        v-on="inputListeners"
      />
      <span v-if="show" class="placeholder" @click="onClick">{{ placeholder }}</span>
    </span>
    <slot></slot>
    <p v-if="errorText" class="error">{{ errorText }}</p>
  </span>
</template>

<script>
export default {
  name: 'ZInput',
  inheritAttrs: false,
  props: {
    element: {
      type: String,
      default: 'input'
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Array, Object],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 200
    },
    error: {
      type: String,
      default: ''
    }
  },
  data() {
    const isSuport = 'placeholder' in document.createElement('input')

    return {
      isSuport,
      show: !isSuport,
      errorText: this.error
    }
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        blur: (event) => {
          if (!this.isSuport && event.target.value === '') {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.show = true
          }
          this.$emit('blur', event.target.value)
        },
        input: (event) => {
          if (!this.isSuport) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.show = event.target.value === ''
          }
          this.$emit('input', event.target.value)
        }
      }
    }
  },
  beforeUpdate() {
    this.show = !this.isSuport && this.value === ''
  },
  methods: {
    onClick() {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="postcss">
.z-input {
  height: 30px;
  line-height: 20px;
  display: inline-block;

  .z-input-inner {
    display: inline-block;
    position: relative;
    height: 100%;
    width: 100%;

    .placeholder {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100%;
      padding: 5px;
      font-size: 13px;
      color: #999;
    }

    input,
    textarea {
      border: 1px solid #ccc;
      padding: 5px;
      font-size: 13px;
      border-radius: 5px;
      height: 100%;
      width: 100%;
      line-height: 20px;

      &:focus {
        border-color: #2d8cf0;
      }
    }
  }
}
</style>
